import React from 'react'

// Icons
import IconLink from './images/iconLink'
import IconLinkDisabled from './images/iconLinkDisabled'

// Styles
import './styles.scss'

export default ({
  disabled,
  title,
  onClick,
}: {
  disabled?: boolean
  title: string
  onClick: () => void
}) => {
  return (
    <button disabled={disabled} className={'button-link'} onClick={onClick}>
      {disabled ? <IconLinkDisabled /> : <IconLink />}
      {disabled ? null : <span dangerouslySetInnerHTML={{ __html: title }} />}
    </button>
  )
}
